import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const percentMask = rawValue => {
  let numberMask = createNumberMask({
    prefix: '',
    allowDecimal: true,
    decimalLimit: 2,
    requireDecimal: true,
    includeThousandsSeparator: false,
  });
  let mask = numberMask(rawValue);

  let decimalsRegex = /\.([0-9]{1,2})/;
  let result = decimalsRegex.exec(rawValue);
  // In case there is only one decimal
  if (result && result[1].length < 2) {
    mask.push('0');
  } else if (!result) {
    mask.push('0');
    mask.push('0');
  }

  return mask;
};

const PercentageMask = props => {
  const { inputRef, ...other } = props;

  return <MaskedInput {...other} ref={inputRef} mask={percentMask} guide={false} showMask />;
};

PercentageMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default PercentageMask;
